<template>
  <p class="body-2">
    By
    <span v-for="(author, index) in authorData" :key="index">
      <router-link
        :to="{
          name: 'ArticleTerm',
          params: {
            slug: author.slug,
            type: 'author',
          },
        }"
        :ga4-event="
          JSON.stringify({
            click_type: 'author_name',
            component: `${parent}`,
            content_group: 'blog',
            gtm_tag: 'link',
            link_text: `${author.name}`,
            link_url: `${author.slug}`,
          })
        "
        v-html="author.name"
      ></router-link>
      <span v-if="checkLength(authorData.length, index, 'two')">&nbsp;and&nbsp;</span>
      <span v-if="checkLength(authorData.length, index, 'many')">
        {{ checkLength(authorData.length, index, '') ? ',&nbsp;' : ',&nbsp;and&nbsp;' }}
      </span>
    </span>
  </p>
</template>

<script setup lang="ts">
import { Coauthors } from '@/types/blog.interface';
import { useRouteParent } from '@/composables/Common.js';

defineProps<{
  authorData: Array<Coauthors>;
}>();

const { parent } = useRouteParent();

function checkLength(length: number, index: number, type: string): boolean {
  if (type == 'two') {
    return length === 2 && index !== 1;
  }

  if (type === 'many') {
    return length > 2 && index !== length - 1;
  }

  return index !== length - 2;
}
</script>
